// extracted by mini-css-extract-plugin
export var loadingSpinner = "_x-0";